export const environment = {
  production: false,
  apiAddress: 'https://testing-api.avs-digital.de/',
  googleMapsEnabled: true,
  googleMapsApiKey: 'AIzaSyBcos3aEaS6CkhPm_2YPTrbv3f1XUH6Hf0',
};
